app.controller('baseOfCaseStateOfHealthController', ['$scope', '$state', '$stateParams', '$translate', 'objectHelper', 'baseModel', 'applicationModel', 'visitModel', 'userModel', 'patientModel', 'allergyModel', 'vaccinationAndSerumModel', 'takenDrugModel', 'geneticDisorderModel', 'baseOfCaseModel',
    function ($scope, $state, $stateParams, $translate, objectHelper, baseModel, applicationModel, visitModel, userModel, patientModel, allergyModel, vaccinationAndSerumModel, takenDrugModel, geneticDisorderModel, baseOfCaseModel) {

        function setData() {
            $scope.stateOfHealth = {};
            $scope.idVisitCard = $stateParams.idVisitCard;
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on(Event.BASE_OF_CASE.GET_ANONYMIZED_STATE_OF_HEALTH.SUCCESS, function(event, stateOfHealth) {
                $scope.stateOfHealth = stateOfHealth;
            });

        }

        function setActions() {
            $scope.goToSearchPage = function () {
                $state.go(Constant.STATE.APP.BASE_OF_CASE.SEARCH);
            };
        }

        function configureInterface() {
        }

        function initialize() {
            baseOfCaseModel.getAnonymizedStateOfHealth($stateParams.idVisitCard);
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        initialize();
        configureInterface();
    }
]);